export const ActionTypes = {
	LOGIN_REQUEST: "LOGIN_REQUEST",
	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	LOGIN_FAILURE: "LOGIN_FAILURE",
	LOGOUT: "LOGOUT",

	ALERT_SUCCESS: "ALERT_SUCCESS",
	ALERT_ERROR: "ALERT_ERROR",
	ALERT_CLEAR: "ALERT_CLEAR",

	///NOTIFICATION ACTIONS
	FETCH_NOTIFICATION_REQUEST: "FETCH_NOTIFICATION_REQUEST",
	FETCH_NOTIFICATION_SUCCESS: "FETCH_NOTIFICATION_SUCCESS",
	FETCH_NOTIFICATION_FAILURE: "FETCH_NOTIFICATION_FAILURE",

	ADD_NOTIFICATION: "ADD_NOTIFICATION",

	COMP_CHECK_REQUEST: 'COMP_CHECK_REQUEST',
	COMP_CHECK_SUCCESS: 'COMP_CHECK_SUCCESS',
	COMP_CHECK_FAILURE: 'COMP_CHECK_FAILURE',

	MARK_NOTIFICATION_READ_REQUEST: "MARK_NOTIFICATION_READ_REQUEST",
	MARK_NOTIFICATION_READ_SUCCESS: "MARK_NOTIFICATION_READ_SUCCESS",
	MARK_NOTIFICATION_READ_FAILURE: "MARK_NOTIFICATION_READ_FAILURE",

	CLEAR_UNREAD_REQUEST: "CLEAR_UNREAD_REQUEST",
	CLEAR_UNREAD_SUCCESS: "CLEAR_UNREAD_SUCCESS",
	CLEAR_UNREAD_FAILURE: "CLEAR_UNREAD_FAILURE",

	FOLLOW_COMPETITOR_REQUEST: "FOLLOW_COMPETITOR_REQUEST",
	FOLLOW_COMPETITOR_SUCCESS: "FOLLOW_COMPETITOR_SUCCESS",
	FOLLOW_COMPETITOR_FAILURE: "FOLLOW_COMPETITOR_FAILURE",

	UNFOLLOW_COMPETITOR_REQUEST: "UNFOLLOW_COMPETITOR_REQUEST",
	UNFOLLOW_COMPETITOR_SUCCESS: "UNFOLLOW_COMPETITOR_SUCCESS",
	UNFOLLOW_COMPETITOR_FAILURE: "UNFOLLOW_COMPETITOR_FAILURE",

	DASHBOARD_HEADER_REQUEST: "DASHBOARD_HEADER_REQUEST",
	DASHBOARD_HEADER_SUCCESS: "DASHBOARD_HEADER_SUCCESS",
	DASHBOARD_HEADER_FAILURE: "DASHBOARD_HEADER_FAILURE",

	DASHBOARD_VIDEO_REQUEST: "DASHBOARD_VIDEO_REQUEST",
	DASHBOARD_VIDEO_SUCCESS: "DASHBOARD_VIDEO_SUCCESS",
	DASHBOARD_VIDEO_FAILURE: "DASHBOARD_VIDEO_FAILURE",

	PRODUCT_GROUP_LIST_REQUEST: "PRODUCT_GROUP_LIST_REQUEST",
	PRODUCT_GROUP_LIST_SUCCESS: "PRODUCT_GROUP_LIST_SUCCESS",
	PRODUCT_GROUP_LIST_FAILURE: "PRODUCT_GROUP_LIST_FAILURE",

	PRODUCT_GROUP_REQUEST: "PRODUCT_GROUP_REQUEST",
	PRODUCT_GROUP_SUCCESS: "PRODUCT_GROUP_SUCCESS",
	PRODUCT_GROUP_FAILURE: "PRODUCT_GROUP_FAILURE",

	PRODUCT_GROUP_DEMO_LIST_REQUEST: "PRODUCT_GROUP_DEMO_LIST_REQUEST",
	PRODUCT_GROUP_DEMO_LIST_SUCCESS: "PRODUCT_GROUP_DEMO_LIST_SUCCESS",
	PRODUCT_GROUP_DEMO_LIST_FAILURE: "PRODUCT_GROUP_DEMO_LIST_FAILURE",

	DEMO_REQUEST: "DEMO_REQUEST",
	DEMO_SUCCESS: "DEMO_SUCCESS",
	DEMO_FAILURE: "DEMO_FAILURE",

	CONTENT_TYPES_REQUEST: "CONTENT_TYPES_REQUEST",
	CONTENT_TYPES_SUCCESS: "CONTENT_TYPES_SUCCESS",
	CONTENT_TYPES_FAILURE: "CONTENT_TYPES_FAILURE",

	CALENDAR_REQUEST: "CALENDAR_REQUEST",
	CALENDAR_SUCCESS: "CALENDAR_SUCCESS",
	CALENDAR_FAILURE: "CALENDAR_FAILURE",

	FEEDBACK_SUCCESS: "FEEDBACK_SUCCESS",
	FEEDBACK_FAILURE: "FEEDBACK_FAILURE",
	FEEDBACK_SUBMIT: "FEEDBACK_SUBMIT",

	SURVEY_SUCCESS: "SURVEY_SUCCESS",
	SURVEY_FAILURE: "SURVEY_FAILURE",
	SURVEY_SUBMIT: "SURVEY_SUBMIT",

	METRIC_SUCCESS: "METRIC_SUCCESS",
	METRIC_FAILURE: "METRIC_FAILURE",
	METRIC_SUBMIT: "METRIC_SUBMIT",

	COMPETITOR_REQUEST: "COMPETITOR_REQUEST",
	COMPETITOR_SUCCESS: "COMPETITOR_SUCCESS",
	COMPETITOR_FAILURE: "COMPETITOR_FAILURE",

	SINGLE_CLICK_REQUEST: "SINGLE_CLICK_REQUEST",
	SINGLE_CLICK_SUCCESS: "SINGLE_CLICK_SUCCESS",
	SINGLE_CLICK_FAILURE: "SINGLE_CLICK_FAILURE",

	SINGLE_CLICK_TYPE_REQUEST: "SINGLE_CLICK_TYPE_REQUEST",
	SINGLE_CLICK_TYPE_SUCCESS: "SINGLE_CLICK_TYPE_SUCCESS",
	SINGLE_CLICK_TYPE_FAILURE: "SINGLE_CLICK_TYPE_FAILURE",

	COMPETITOR_PRODUCTS_REQUEST: "COMPETITOR_PRODUCTS_REQUEST",
	COMPETITOR_PRODUCTS_SUCCESS: "COMPETITOR_PRODUCTS_SUCCESS",
	COMPETITOR_PRODUCTS_FAILURE: "COMPETITOR_PRODUCT_FAILURE",

	RESOURCE_TYPES_REQUEST: "RESOURCE_TYPES_REQUEST",
	RESOURCE_TYPES_SUCCESS: "RESOURCE_TYPES_SUCCESS",
	RESOURCE_TYPES_FAILURE: "RESOURCE_TYPES_FAILURE",

	RESOURCES_REQUEST: "RESOURCE_REQUEST",
	RESOURCES_SUCCESS: "RESOURCE_SUCCESS",
	RESOURCES_FAILURE: "RESOURCE_FAILURE",

	ADMIN_DASHBOARD_TABLE_REQUEST: "ADMIN_DASHBOARD_TABLE_REQUEST",
	ADMIN_DASHBOARD_TABLE_SUCCESS: "ADMIN_DASHBOARD_TABLE_SUCCESS",
	ADMIN_DASHBOARD_TABLE_FAILURE: "ADMIN_DASHBOARD_TABLE_FAILURE",

	ADMIN_DASHBOARD_FREQUENCY_REQUEST: "ADMIN_DASHBOARD_FREQUENCY_REQUEST",
	ADMIN_DASHBOARD_FREQUENCY_SUCCESS: "ADMIN_DASHBOARD_FREQUENCY_SUCCESS",
	ADMIN_DASHBOARD_FREQUENCY_FAILURE: "ADMIN_DASHBOARD_FREQUENCY_FAILURE",

	ADMIN_DASHBOARD_TRAFFIC_REQUEST: "ADMIN_DASHBOARD_TRAFFIC_REQUEST",
	ADMIN_DASHBOARD_TRAFFIC_SUCCESS: "ADMIN_DASHBOARD_TRAFFIC_SUCCESS",
	ADMIN_DASHBOARD_TRAFFIC_FAILURE: "ADMIN_DASHBOARD_TRAFFIC_FAILURE",

	ADMIN_DASHBOARD_ENABLED_TOTALS_REQUEST: "ADMIN_DASHBOARD_ENABLED_TOTALS_REQUEST",
	ADMIN_DASHBOARD_ENABLED_TOTALS_SUCCESS: "ADMIN_DASHBOARD_ENABLED_TOTALS_SUCCESS",
	AADMIN_DASHBOARD_ENABLED_TOTALS_FAILURE: "AADMIN_DASHBOARD_ENABLED_TOTALS_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_COMPETITORS_REQUEST: "ADMIN_DATA_MANAGER_TABLE_COMPETITORS_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_COMPETITORS_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_COMPETITORS_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_COMPETITORS_FAILURE: "ADMIN_DATA_MANAGER_TABLE_COMPETITORS_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_REQUEST: "ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_FAILURE: "ADMIN_DATA_MANAGER_TABLE_COMPETITOR_PRODUCTS_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_RESOURCES_REQUEST: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_RESOURCES_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_RESOURCES_FAILURE: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_REQUEST: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_FAILURE: "ADMIN_DATA_MANAGER_TABLE_RESOURCES_TYPE_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_REQUEST: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_FAILURE: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPE_FAILURE",

	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_REQUEST: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_REQUEST",
	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_SUCCESS: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_SUCCESS",
	ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_FAILURE: "ADMIN_DATA_MANAGER_TABLE_SINGLE_CLICK_TYPES_RESOURCES_FAILURE",

	ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_REQUEST: "ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_REQUEST",
	ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_SUCCESS: "ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_SUCCESS",
	ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_FAILURE: "ADMIN_DATA_MANAGER_COMPETITOR_PRODUCT_TYPES_FAILURE",

	ADMIN_USER_FEEDBACK_REQUEST: "ADMIN_USER_FEEDBACK_REQUEST",
	ADMIN_USER_FEEDBACK_SUCCESS: "ADMIN_USER_FEEDBACK_SUCCESS",
	ADMIN_USER_FEEDBACK_FAILURE: "ADMIN_USER_FEEDBACK_FAILURE",

	STORAGE_APPLICATIONS_REQUEST: "STORAGE_APPLICATIONS_REQUEST",
	STORAGE_APPLICATIONS_SUCCESS: "STORAGE_APPLICATIONS_SUCCESS",
	STORAGE_APPLICATIONS_FAILURE: "STORAGE_APPLICATIONS_FAILURE",

	APPLICATION_PRIMARY_REQUEST: "APPLICATION_PRIMARY_REQUEST",
	APPLICATION_PRIMARY_SUCCESS: "APPLICATION_PRIMARY_SUCCESS",
	APPLICATION_PRIMARY_FAILURE: "APPLICATION_PRIMARY_FAILURE",

	APPLICATION_SECONDARY_REQUEST: "APPLICATION_SECONDARY_REQUEST",
	APPLICATION_SECONDARY_SUCCESS: "APPLICATION_SECONDARY_SUCCESS",
	APPLICATION_SECONDARY_FAILURE: "APPLICATION_SECONDARY_FAILURE",

	ADMIN_STORAGE_APPLICATIONS_REQUEST: "ADMIN_STORAGE_APPLICATIONS_REQUEST",
	ADMIN_STORAGE_APPLICATIONS_SUCCESS: "ADMIN_STORAGE_APPLICATIONS_SUCCESS",
	ADMIN_STORAGE_APPLICATIONS_FAILURE: "ADMIN_STORAGE_APPLICATIONS_FAILURE",

	ADMIN_APPLICATION_PRIMARY_REQUEST: "ADMIN_APPLICATION_PRIMARY_REQUEST",
	ADMIN_APPLICATION_PRIMARY_SUCCESS: "ADMIN_APPLICATION_PRIMARY_SUCCESS",
	ADMIN_APPLICATION_PRIMARY_FAILURE: "ADMIN_APPLICATION_PRIMARY_FAILURE",

	ADMIN_APPLICATION_SECONDARY_REQUEST: "ADMIN_APPLICATION_SECONDARY_REQUEST",
	ADMIN_APPLICATION_SECONDARY_SUCCESS: "ADMIN_APPLICATION_SECONDARY_SUCCESS",
	ADMIN_APPLICATION_SECONDARY_FAILURE: "ADMIN_APPLICATION_SECONDARY_FAILURE"
};
